<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="会员中心-会员等级管理"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box item-search" v-if="isMain">
                <el-button type="primary" icon="el-icon-plus" @click="addEvent">添加会员等级</el-button>
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil" header-cell-class-name="table-ceil"
                    >
                        <!--<el-table-column type="index" label="ID"></el-table-column>-->
                        <el-table-column prop="vip_name" label="会员等级名称" size="200"></el-table-column>
                        <el-table-column prop="discount" label="会员权益" size="200">
                            <template slot-scope="scope">
                                <span v-if="scope.row.discount">
                                    {{scope.row.discount}}
                                </span>
                                <span v-else></span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="操作" v-if="isMain">
                            <template slot-scope="scope">
                                <el-button
                                        size="mini"
                                        type="danger"
                                        @click="handleDelete(scope.$index, scope.row)"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="blank10"></div>
                    <div class="table-tools">
                        <div class="tool">
                            <el-dropdown trigger="click" placement="top-end" @command="handleCommand">
                                <span class="el-dropdown-link">
                                    <el-button size="medium">批量操作</el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit-name" v-if="isMain">修改等级名称</el-dropdown-item>
                                    <el-dropdown-item command="edit-discount">设置会员折扣</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="blank10"></div>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">
            <!--右下-->
        </div>

        <!--添加/修改会员等级-->
        <pop-form :state="editShow">
            <template v-slot:title>{{editTitle}}</template>
            <el-form ref="editData" :model="editData" :rules="editRules" label-width="100px">
                <el-form-item label="等级名称" prop="vip_name">
                    <el-input v-model="editData.vip_name" placeholder="请输入会员等级名称" @keypress.native="e => {if(e.charCode === 13) submitSave();}"></el-input>
                </el-form-item>
            </el-form>
            <template v-slot:foot>
                <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button size="medium" @click="cancelSave">&nbsp;&nbsp;关闭&nbsp;&nbsp;</el-button>
            </template>
        </pop-form>

        <!--批量修改会员等级名称-->
        <edit-vip-name v-model="editVipNameState" :list-data="tableData" @done="setVipNameDone"></edit-vip-name>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import PopForm from "@/model/PopForm";
    import RightTop from "@/model/RightTop";
    import EditVipName from "@/model/StoreUser/EditVipName";
    export default {
        name: "VipList",
        components: {EditVipName, RightTop, PopForm, SearchBox, Menu},
        data: () => ({
            tableAttr:{
                width: "100%",
                height: "100%"
            },
            tableData: [],

            editShow: false,
            editTitle: "",
            editData: {
                vip_id: null,
                vip_name: "",
            },
            editRules: {
                vip_name: [
                    {required: true, message: "请填写会员等级名称"},
                ]
            },

            //批量修改名称
            editVipNameState: false,
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function(){
            this.$store.commit("setMenuId", "5-1");
            this.loadListData();
        },
        methods: {
            //添加按钮点击
            addEvent: function () {
                this.editTitle = "添加会员等级";
                this.editData = {
                    vip_id: null,
                    vip_name: "",
                    discount: ""
                };
                this.editShow = true;
            }

            //编辑
            ,handleEdit: function (index, data) {
                this.editTitle = "修改会员等级";
                this.editData = {
                    vip_id: data.vip_id,
                    vip_name: data.vip_name
                };
                this.editShow = true;
            }

            //提交表单
            ,submitSave: function () {
                this.$refs.editData.validate( valid => {
                    if(!valid) return ;

                    if(!this.editData.vip_id) {
                        //添加
                        obj.postData("store_vip/add_vip", this.editData, res => {
                            if(res.errcode === 0) {
                                obj.message.success("添加成功");
                                this.loadListData();
                            }else
                                obj.message.error(res.errdesc);
                        });
                    } else {
                        //修改
                        obj.postData("store_vip/set_vip", this.editData, res => {
                            if(res.errcode === 0) {
                                obj.message.success("修改成功");
                                this.loadListData();
                            }else
                                obj.message.error(res.errdesc);
                        });
                    }
                    this.editShow = false;

                });
            }

            //取消提交
            ,cancelSave: function () {
                this.editShow = false;
            }

            //加载列表数据
            ,loadListData: function () {
                obj.postData("store_vip/get_vip_list", {}, function (res) {
                    if(res.errcode === 0){
                        this.tableData = res.data;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }

            //批量操作
            ,handleCommand: function (c) {
                if(c === "edit-name"){
                    this.editVipNameState = true;
                }else if(c === "edit-discount"){
                    this.$root.go("user/vip_discount");
                }
            }
            //批量修改完成
            ,setVipNameDone: function (listData) {
                this.loadListData();
            }
            //删除
            ,handleDelete: function (index, fieldData) {
                obj.postData("store_vip/delete_vip", {vip_id: fieldData.vip_id}, res => {
                    if(res.errcode === 0) {
                        obj.message.success("删除完成");
                        this.loadListData();
                    }else
                        obj.message.error(res.errdesc);
                });
            }
        }
    }
</script>

<style scoped>
    .layout-right-body>.item-search{
        height: 72px;
        line-height: 72px;
        padding: 0px 16px;
    }
</style>
